import Query from 'query/Query';
import React from 'react';
import './DataTable.css';
import { Filter } from './filter/Filter';

export interface FilterPaneProps {
    query: Query;
    onChanged: () => void;
}

export interface FilterPaneState {

}

export class FilterPane extends React.Component<FilterPaneProps, FilterPaneState> {
    constructor(props: Readonly<FilterPaneProps>) {
        super(props);
        this.state = {
        };
    }

    render = () => {
        return <div className="datatable-filterdiv">
            <Filter
                query={this.props.query}
                clause={this.props.query.filter}
                onChanged={this.onChanged}></Filter>
        </div>
    }

    onChanged: () => void = () => {
        this.props.onChanged();
    }

}